import React from 'react';
import {
  Box,
  ButtonGroup,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import AddCircle from 'src/components/Icons/ModifiedMUIIcons/AddCircle';
import RemoveCircle from 'src/components/Icons/ModifiedMUIIcons/RemoveCircle';

interface Props {
  quantity: number;
  onAdd: () => void;
  onRemove: () => void;
  isSoldOut: boolean;
}

const AddRemoveSummaryItems: React.FC<Props> = ({
  quantity,
  onAdd,
  onRemove,
  isSoldOut,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <ButtonGroup disableElevation size="small" variant="contained">
        <IconButton color="primary" onClick={onRemove} sx={{ pb: 0.5 }}>
          <RemoveCircle
            fontSize="large"
            color={theme.palette.primary.main}
            backgroundColor={theme.palette.primary.contrastText}
          />
        </IconButton>
        <Typography
          variant="body1"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 0.5,
            pt: 0.5,
          }}
        >
          {quantity}
        </Typography>
        <IconButton
          color="primary"
          onClick={onAdd}
          sx={{ pb: 0.5 }}
          disabled={isSoldOut}
        >
          <AddCircle
            color={
              isSoldOut ? theme.palette.grey[500] : theme.palette.primary.main
            }
            backgroundColor={theme.palette.primary.contrastText}
            fontSize="large"
          />
        </IconButton>
      </ButtonGroup>
    </Box>
  );
};

export default AddRemoveSummaryItems;
